import { isObject } from 'lodash';
import React from 'react';
import { FormContextType } from '../FormContext';
import { FormTextHelper } from '../types';

const getErrorMessage = (error) => {
    if (
        isObject(error) &&
        'message' in error &&
        (typeof error.message === 'string' || React.isValidElement(error.message))
    ) {
        return error.message;
    }
};

const getError = (error) => {
    const errorMessage = getErrorMessage(error);
    if (errorMessage) {
        return errorMessage;
    }
    if (isObject(error) && 'item' in error) {
        return getErrorMessage(error.item);
    }
    if (React.isValidElement(error) || typeof error === 'string') {
        return error;
    }
};
export const getMessage = ({
    isError,
    error,
    isSuccess,
    success,
    hint,
}: FormContextType): FormTextHelper['error'] | FormTextHelper['success'] | FormTextHelper['hint'] => {
    if (isError) {
        return getError(error);
    }

    if (isSuccess) {
        return success;
    }

    return hint;
};
